// @flow
import React, { useState, useRef, useEffect } from "react";
import { Text, Input, Flex } from "@unifize/sarah";

import DragHandleIcon from "src/components/Unifize/DragHandle";
import Tooltip from "src/components/Tooltip";
import Icon from "src/icons";
import * as colors from "src/styles/constants/colors";

import { MakeDefaultContainer, OptionRow, ActionsContainer } from "./styles";

type Props = {
  handleAddNewOption: (option: string, shouldMakeDefault?: boolean) => void,
  isCheckbox: boolean,
  optionsLength: number,
};

const AddOption = ({
  handleAddNewOption,
  isCheckbox,
  optionsLength,
}: Props) => {
  const [newOption, setNewOption] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleChange = (e) => {
    setNewOption(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && newOption && newOption.trim() !== "") {
      handleAddNewOption(newOption);
      setNewOption("");
    }
  };

  const handleBlur = () => {
    if (newOption && newOption.trim() !== "") {
      handleAddNewOption(newOption);
      setNewOption("");
    }
  };

  const handlePaste = (e) => {
    const paste = e.clipboardData.getData("text");
    if (paste.includes("\n")) {
      e.preventDefault();
      const lines = paste
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line !== "");
      lines.forEach((line) => handleAddNewOption(line, false));
      setNewOption("");
    }
  };

  return (
    <Flex direction="row" space="3" align="center">
      <DragHandleIcon style={{ opacity: 0.3, cursor: "not-allowed" }} />
      <OptionRow disabledActions>
        {isCheckbox && optionsLength === 2 ? (
          <Tooltip
            title='Can be enabled when "Convert picklist to checkbox" is disabled'
            placement="right"
          >
            <Input
              ref={inputRef}
              value={newOption}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              onBlur={handleBlur}
              onPaste={handlePaste}
              placeholder="Enter value"
              disabled
              style={{
                width: "576px",
              }}
            />
          </Tooltip>
        ) : (
          <Input
            ref={inputRef}
            value={newOption}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            onPaste={handlePaste}
            placeholder="Enter value"
            style={{
              width: "576px",
            }}
          />
        )}
        <ActionsContainer>
          <Icon
            type="delete"
            height={16}
            width={16}
            style={{
              cursor: "not-allowed",
              opacity: 0.3,
            }}
          />
          <MakeDefaultContainer disabled onClick={() => {}}>
            <Icon height={20} width={20} type="circularCheck" />
            <Text color={colors.grey42}>Make default value</Text>
          </MakeDefaultContainer>
        </ActionsContainer>
      </OptionRow>
    </Flex>
  );
};

export default AddOption;
